export const PORTRAIT_WIDTH = 322
